'use client'

import { Chip, Flex, Group, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { useUpdateSearchParams } from '@/hooks/routing'

import {
  COINS_OG_PAGE_SIZE,
  COINS_PAGE_SIZE,
  CoinTab,
  defaultCoinTab,
  getCoinTabs,
} from '../../configs'
import { useCoinsTableStore } from '../../context'
import styles from './styles.module.css'

export default function CoinTabs({ isOGPrice }: { isOGPrice?: boolean }) {
  const pageSize = isOGPrice ? COINS_OG_PAGE_SIZE : COINS_PAGE_SIZE
  let coinTabs = useMemo(() => getCoinTabs(pageSize), [pageSize])

  if (isOGPrice) coinTabs = coinTabs.filter(tab => tab.value !== CoinTab.Favorites)
  const currentCoinTab = useCoinsTableStore(state => state.currentCoinTab)
  const updateFilters = useCoinsTableStore(state => state.updateFilters)

  const { updateSearchParams } = useUpdateSearchParams(true, false, true)

  const t = useTranslations('common.coinCategoryTypes')

  const handleTabClick = (tabValue: string) => {
    const newCurrentCoinTab = coinTabs.find(tab => tab.value === tabValue) ?? defaultCoinTab
    updateFilters({
      currentCoinTab: newCurrentCoinTab,
      currentPage: 1,
    })

    updateSearchParams([
      { name: 'tab', value: tabValue, deleteParam: tabValue === defaultCoinTab.value },
      { name: 'page', deleteParam: true },
    ])
  }

  return (
    <Flex className={styles.container}>
      <Chip.Group multiple={false} value={currentCoinTab.value} onChange={handleTabClick}>
        <Group className={styles.tabs}>
          {coinTabs.map(tab => (
            <Chip
              key={tab.value}
              icon={null}
              classNames={styles}
              variant="outline"
              value={tab.value}
              onClick={() => handleTabClick(tab.value)}
            >
              <Text variant="subtitle-emphasis">{t(tab.labelTranslationKey)}</Text>
            </Chip>
          ))}
        </Group>
      </Chip.Group>
    </Flex>
  )
}
